import ukData from './countries/uk/uk';
import usData from './countries/us/us';

const cardData = {
  us: usData,
  uk: ukData,
};



export default cardData;
